module.exports = __webpack_public_path__ + "ed3dccd8a90521fa5429ef98e18bd140.pdf";